
import { store } from '../App'
import { SET_NOTIFICATION } from '../store/cafe/actionTypes'


class HeliocorStorage {

    static setMultipleItems = (items, backup) => {
        try{
            items.forEach(item => localStorage.setItem(item.key, JSON.stringify(item.value)))
            store.dispatch({type: SET_NOTIFICATION, notification: {text: 'warning.successSaveAll', type:'success'}})
            return true
        }catch(error){
            backup.forEach(item => item.value && localStorage.setItem(item.key, item.value))
            store.dispatch({type: SET_NOTIFICATION, notification: {text:'warning.localStorageError', type:'warning'}})
        }
    }

    static setItem = (key, value) => {
        try{
            localStorage.setItem(key, value)
            return true
        }catch(error){
            error && store.dispatch({type: SET_NOTIFICATION, notification: {text:'warning.localStorageError', type:'warning'}})
        }
    }

    static getItem = (key) => {
        try{
            return localStorage.getItem(key)
        }catch (e){
            return false
        }
    }

    static removeItem = (key) => {
        try{
            localStorage.removeItem(key)
            return true
        }catch (e){
            return false
        }
    }

    static clear = () => {
        try{
            localStorage.clear()
            return true
        }catch (e){
            return false
        }
    }
}

export default HeliocorStorage